import ElectronApi from './ElectronApi';

const api = new ElectronApi();
function makeApi(): ElectronApi | undefined {
  return api;
}

export default makeApi;
